export default {
  // ORIGIN: "http://localhost:8080", // local. used for cors
  GENERIC_ERROR:
    "An unexpected error occurred. Please try again later or contact support for assistance.",

  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 10,
  DEFAULT_SECTION: -1, // all sections
  DEFAULT_PLATOON: -1, // all platoons
  DEFAULT_WORKOUT_TYPE: -1, // all workouts

  DMY_TS_FORMAT: "DD-MM-YYYY HH:mm",
  DMY_TS_RANGE_FORMAT: "ddd, D MMM, HH:mm",
  DAY_OF_WEEK_TS_FORMAT: "ddd, D MMM",
  PERIOD_TS_FORMAT: "DD MMM YYYY, ddd",
  DB_FORMAT: "YYYY-MM-DD HH:mm",
  BUCKET_FORMAT: "YYYY-MM-DD",
  PERIOD_FORMAT: "MMM DD",
  DATE_RANGE_FORMAT: "MMM dd",
  MDY_TS_FORMAT: "MM-DD-YYYY HH:mm",
  DATETIME_FORMAT: "yyyy-MM-dd hh:mm:ss a",
  TIME_FORMAT: "hh:mm a",

  SNACKBAR_DURATION: {
    FAST: 3500,
    MEDIUM: 7500,
    SLOW: 15000,
  },
  MIN_PASSWORD_LEN: 8,

  MAX_STRAIN: 21,
  MAX_RECOVERY_SCORE: 100,
  MAX_SLEEP_SCORE: 100,

  STRAIN_LOW: 13,
  STRAIN_HIGH: 18,
  RECOVERY_DANGER: 33,
  RECOVERY_WARNING: 66,
  SLEEP_DANGER: 49,
  SLEEP_WARNING: 79,

  SLEEP_STATUS_LIGHT: 1,
  SLEEP_STATUS_REM: 2,
  SLEEP_STATUS_DEEP: 3,
  SLEEP_STATUS_AWAKE: 4,

  BATTERY_LEVEL_VERY_LOW: 20,
  BATTERY_LEVEL_LOW: 40,
  BATTERY_LEVEL_AVERAGE: 65,
  BATTERY_LEVEL_HIGH: 90,
  BATTERY_LEVEL_MAX: 100,

  CHART_DATE_FORMAT: "MMM D",
  CHART_DATE_DAY_OF_WEEK_FORMAT: "ddd",
  TABLE_DATE_FORMAT: "ddd, D MMM",
  TABLE_DATETIME_FORMAT: "ddd, D MMM, HH:mm",
  TABLE_DOB_FORMAT: "DD MMM YYYY",
  TABLE_DAY_OF_WEEK_DATETIME_FORMAT: "ddd, D MMM, HH:mm",
  TABLE_DAY_OF_WEEK_DATETIME_YEAR_FORMAT: "ddd, D MMM YYYY, HH:mm",
  TABLE_TIME_FORMAT: "HH:mm",
  TABLE_HOURS_MINUTES_FORMAT: "H[h] mm[m]",
  TABLE_DATETIME_YEAR_FORMAT: "D MMM YYYY, HH:mm",


  MAX_WORKOUTS: 3,
  WORKOUT_TYPE_ID: {
    OUTDOOR_RUN: 1,
    OUTDOOR_WALK: 2,
    OUTDOOR_CYCLE: 3,
    INDOOR_RUN: 5,
    POOL_SWIM: 6,
    INDOOR_CYCLE: 7,
    INDOOR_WALK: 13,
    JUMP_ROPE: 21,
    ELLIPTICAL: 134,
    ROWER: 135,
    OTHER: 255, // Free training
  },
  SWIM_MAIN_STROKES: [
    "Breast Stroke",
    "Freestyle",
    "Butterfly",
    "Back Stroke",
    "Medley",
  ],
  ALERT_HRV: "HRV",
  ALERT_RHR: "RHR",
  ALERT_SPO: "SPO",
  SECTIONS: ['DEFAULT','ALPHA','BETA','CHARLIE','DELTA'],
  DISTANCE_WORKOUT_TYPES: [1,2,5,13],
  TIME_12_HRS_FORMAT: 'hh:mm a',
  TIME_24_HRS_FORMAT: 'hh:mm',
  FILTER_LOW_BATTERY: 'LOW_BATTERY',
  FILTER_RECENT_INACTIVE: 'RECENT_INACTIVE',
  FILTER_PROLONGED_INACTIVE: 'PROLONGED_INACTIVE',
  FILTER_EXTENDED_INACTIVE: 'EXTENDED_INACTIVE',
  FILTER_LOW_BATTERY_TITLE: 'Battery level less than 20%',
  FILTER_RECENT_INACTIVE_TITLE: 'Last synced device 7 to 13 days ago',
  FILTER_PROLONGED_INACTIVE_TITLE: 'Last synced device 14 to 29 days ago',
  FILTER_EXTENDED_INACTIVE_TITLE: 'Last synced device more than 30 days ago',

  SORT_ASC: 'asc',
  SORT_DESC: 'desc',

  STRESS_SORT_COLUMN : 'stress_timestamp',
  WORKOUT_INTENSITY_COLORS: {
    REST: "#8A74E6",
    WARM_UP: "#74B8E6",
    FAT_BURNING: "#96F189",
    AEROBIC: "#FFE14B",
    ANAEROBIC: "#E57E12",
    EXTREME: "#D20000",
  },
  PERFORMANCE_RANGE: {
    POOR: 'POOR',
    OK: 'OK',
    BETTER: 'BETTER'
  },
  SLEEP_SORT_COLUMN : 'sleep_timestamp',
  ROLES: {
    ADMIN: 1,
    USER: 2,
    SUPER_ADMIN: 3,
    PLATOON_COMMANDER: 4,
    USER_MANAGER: 5,
  },
  ADMIN_USER_ROLES: [1,3,5],
  CMNDR_RSTRCTD_ROLES: [1,3,4,5],
  CMNDR_EDT_RSTRCTD_ROLES: [1,3,5],
  USR_MNGR_RSTRCTD_ROLES: [1,3,4,5],
  USR_MNGR_EDT_RSTRCTD_ROLES: [1,3,4],
  WORKOUT_ZONES: {
    REST: 'resting-zone',
    WARM_UP: 'warmup-zone',
    FAT_BURNING: 'fat-burning-zone',
    AEROBIC: 'aerobic-zone',
    ANAEROBIC: 'anaerobic-zone',
    EXTREME: 'extreme-zone',
  },
  CMNDRS : { 
    CDACMNDR: 'CDACMNDR',
    ADCDACMNDR: 'ADCDACMNDR',
    CDAADMIN: 'cda_admin'
  },
  DISPLAY_PROFILE_TYPES: false,
  DISPLAY_DNA: false,
};

